export const searchCodeConstants = {
    CLEAR_PAGE_STATE: 'CLEAR_PAGE_STATE',
    GET_CODE_SUCCESS: 'GET_CODE_SUCCESS'
 };
 